import { createRoot, hydrateRoot } from 'react-dom/client';
import { HomePage } from './app/HomePage';
import { localeFromLang } from './i18n/locale';
import { useDocumentMeta } from './i18n/meta';
import './styles/base.css';
import './styles/motion.css';
import './styles/layout.css';

const locale = localeFromLang(document.documentElement.lang);
function App() { useDocumentMeta('home', locale); return <HomePage locale={locale} />; }
const root = document.getElementById('root')!;
if (root.firstElementChild) hydrateRoot(root, <App />); else createRoot(root).render(<App />);
